import { Component, Input, OnInit } from "@angular/core";
import { FlujoVentaPaso } from "../../../_models/flujo-venta-paso";
import { TabViewCustom } from "../../../_models/tab-view-custom";
import { SelectItem } from "primeng/api";

@Component({
  selector: 'app-flujo-venta-comite-credito',
  templateUrl: './flujo-venta-comite-credito.component.html',
  styleUrls: ['./flujo-venta-comite-credito.component.css']
})
export class FlujoVentaComiteCreditoComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() titulo: string;
  @Input() listaTiposPersonas: SelectItem[] = [];

  tabSeleccionado = "DATGEN";

  constructor() { }

  ngOnInit() {
  }

  abrirAcordeon(evento: number) {
    switch (evento) {
      case 0: {
        this.tabSeleccionado = "DATGEN";
        break;
      }
      case 1: {
        this.tabSeleccionado = "RESPERXVIN";
        break;
      }
    }
  }

}
